import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import moment from "moment";

const CalendarHeader = ({ days, activeDay, onCellClick }) => (
  <div className="xti-calendar__header">
      {days.map((day, index) => (
        <div
          key={day.date()}
          className={cn('xti-calendar__header-cell', {
            'xti-calendar__header-cell--active': moment(activeDay).isSame(day, 'day')
          })}
          onClick={() => onCellClick(day)}
        >
          <span>{day.format('dd')}</span>
          {day.date()}
        </div>
      ))}
  </div>
);

CalendarHeader.propTypes = {
  days: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default CalendarHeader;
